import { IObjectTypeAccepted } from '../../../actions/userObject/settings/objectTypes'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IObjectTypeAccepted,
): IUserObjectStore {
  return {
    ...state,
    objectType: action.objectTypes,
  }
}
